<!-- splash screen -->
<div #splashScreen class="splash-screen">
	<img src="./assets/media/logos/assistive-logo-dark.png" alt="Logo" class="max-h-45px" />
	<mat-spinner diameter="40"></mat-spinner>
</div>
